var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8191 16.5487C26.9457 16.4281 27.1074 16.3595 27.2661 16.3595H31.3846C31.8071 16.3595 32.1473 16.0178 32.1473 15.5968V10.1055C32.1473 9.68446 31.8071 9.34277 31.3846 9.34277H27.2661C25.2739 9.34277 23.3092 10.1512 21.8723 11.5652C20.4325 13.0144 19.6393 14.9333 19.6393 16.9697V20.327H16.2834C15.8609 20.327 15.5208 20.6672 15.5208 21.0897V26.5795C15.5208 27.0021 15.8609 27.3422 16.2834 27.3422H19.6393V37.5622C19.6393 37.9848 19.981 38.3249 20.402 38.3249H25.8932C26.3142 38.3249 26.6559 37.9848 26.6559 37.5622V27.3422H31.3846C31.8071 27.3422 32.1473 27.0021 32.1473 26.5795V21.0897C32.1473 20.6672 31.8071 20.327 31.3846 20.327H26.6559V16.9697C26.6559 16.8049 26.72 16.6493 26.8191 16.5487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c741cd1e49eb17c5d2ca5bb57fc07f3b.svg";
export { ForwardRef as ReactComponent };